export default ({ imageUrl, imageId, imageType, productData, pdpQuantities, pdpSizeData }) => {
  const url = new URL("/design-lab", window.location.origin);
  url.searchParams.set("artwork_urls", JSON.stringify({ [imageId]: imageUrl }));
  url.searchParams.set("catalog_number", productData.catalogNumber);
  url.searchParams.set("ac", productData.color);
  url.searchParams.set("file_content_type", imageType);

  // Add PDP quantities and size data if available
  if (pdpQuantities) {
    url.searchParams.set("pdp_quantities", JSON.stringify(pdpQuantities));
  }
  if (pdpSizeData) {
    url.searchParams.set("pdp_size_data", JSON.stringify(pdpSizeData));
  }

  return url.toString();
};
